import getLogger from '@ignitesales/logger-es';
import React, { useState } from 'react';
import { QuestionShape } from '../../../shapes/index.mjs';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { useSelector } from 'react-redux';

//TODO: this should be removed, refactored into a pkg, and then make a question group for it

const logger = getLogger({ component: 'DonutChart' });

const DonutChart = (props) => {
  const {
    question,
    page
  } = props.data;

  const isEqual = () => {
    return false;
  };

  const data = useSelector(state => state.data[parseInt(question.inputs) || parseInt(page.key)], isEqual) || {};
  const colors = useSelector(state => state.colors);

  const [ active ] = useState(-1);

  const onSectorHover = (path, over) => {
    logger.debug('DonutChart.onSectorHover()', { path, over });
  };

  const groups = Object.getOwnPropertyNames(data).map(group => data[group]);
  const inputs = groups.reduce((a, c) => {
    const inputs = Object.getOwnPropertyNames(c).map(input => c[input]);
    return [
      ...a, ...inputs.map(d => ({
        appkey: d.appkey,
        label: d.appkey,
        value: +d.value
      }))
    ];
  }, []);

  const getCells = () => {
    return inputs.map((entry, index) => {
      return <Cell
        key={ `cell-${ index }` }
        fill={ active === index ? '#ff0000' : colors[entry.appkey] }
        onMouseEnter={ (e) => onSectorHover(e.target, true) }
        onMouseLeave={ (e) => onSectorHover(e.target, false) }
      />;
    });
  };

  return (
    <ResponsiveContainer debounce={ 1000 }>
      <PieChart margin={ { top: 0, right: 0, left: 0, bottom: 0 } }>
        <Pie
          data={ inputs }
          dataKey="value"
          nameKey="appkey"
          innerRadius="40%"
          outerRadius="90%"
          activeIndex={ active }>
          { getCells() }
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

DonutChart.propTypes = {
  data: QuestionShape,
};

export default DonutChart;
